<template>
    <div class="items-center w-full grid grid-cols-6  text-gray-700 h-16">
        <jet-label
            class="text-white whitespace-nowrap col-span-6 -mt-2 sm:text-base"
            :value="config.text ? config.text : 'Período de datas'"
        />
        <div class="flex col-span-6 w-full gap-4">
            <div
                class="col-span-2 w-full rounded-md p-2 border border-black h-10"
            >
                <div class="w-full grid grid-cols-3" test-id="date-start">
                    <div class="col-span-4 relative w-full">
                        <input
                            id="date_start"
                            type="text"
                            placeholder="Inicial"
                            onfocus="this.type='date'"
                            class="focus:outline-none w-full border-gray-30 h-6"
                            v-model="date.from"
                            @input="changeDate"
                            @focus="focus('from')"
                        />
                    </div>
                </div>
            </div>
            <div
                class="col-span-2 w-full rounded-md p-2 border border-black h-10"
            >
                <div class="w-full grid grid-cols-3" test-id="date-end">
                    <div class="col-span-4 relative w-full ">
                        <input
                            id="date_end"
                            type="text"
                            placeholder="Final"
                            onfocus="this.type='date'"
                            class=" focus:outline-none w-full border-gray-300 h-6"
                            v-model="date.to"
                            @input="changeDate"
                            @focus="focus('to')"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import JetLabel from "../../Jetstream/Label.vue";
import moment from "moment";

export default {
    props: {
        config: { type: Object, default: () => ({}) },
        selectedDateRange: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            moment,
            date: {
                to: "",
                from: ""
            }
        };
    },
    methods: {
        focus(field){
            const formatEntry = this.date[field].includes('-') ? 'YYYY-MM-DD': 'DD/MM/YYYY'
            this.date[field] = moment(this.date[field], formatEntry).format('YYYY-MM-DD')
        },
        changeDate() {
            this.selectedDateRange.to = /\d{2}\/\d{2}\/\d{4}/.test(this.date.to)
                ? moment(this.date.to, "DD/MM/YYYY").format("YYYY-MM-DD")
                : this.date.to;

            this.selectedDateRange.from = /\d{2}\/\d{2}\/\d{4}/.test(
                this.date.from
            )
                ? moment(this.date.from, "DD/MM/YYYY").format("YYYY-MM-DD")
                : this.date.from;

            this.$emit("input", this.selectedDateRange);
        }
    },
    mounted() {
        if (!this.selectedDateRange.to && !this.selectedDateRange.from) return;
        if (this.selectedDateRange.to) {
            this.date.to = moment(this.selectedDateRange.to).format(
                "DD/MM/YYYY"
            );
        }
        if (this.selectedDateRange.from) {
            this.date.from = moment(this.selectedDateRange.from).format(
                "DD/MM/YYYY"
            );
        }
    },
    components: { JetLabel }
};
</script>
<style></style>
